import { Answer } from 'types/answer';
import { rcEnums } from 'types/rc.enums';
import { FeeDto, PaymentMethodTypeEnum, PlatformsEnum, SubPaymentMethodTypeEnum } from '@bondsports/types';
import { PaymentPlanStatusEnum, PaymentPlanTypeEnum } from '@bondsports/types';
import { IPaymentMethodData } from 'components/Invoice/types';
import { RepetitionUnit } from '@bondsports/date-time';

export interface ProductResource {
	type: string;
	id?: number;
	isAll?: boolean;
}
export interface IPaymentProduct {
	id: number;
	ordinal: number;
	unitPrice: number;
	resources?: ProductResource[];
	userId?: number;
}
export interface IPaymentData {
	installmentsAmount: number;
	isPartialPayment: boolean;
	products?: IPaymentProduct[];
	paymentData: {
		token: string;
		type: SelectablePaymentMethodType;
	};
	answers: Answer[] | { userId: number; answers: Answer[] }[];
	amountToPay: number | undefined;
	userId: number;
	signType: rcEnums.league.SignTypeEnum;
	entityId?: number;
}

export interface UserPaymentMethod {
	id: number;
	userId: number;
	isDefault?: boolean;
	paymentMethodType: PaymentMethodTypeEnum;
	subPaymentMethodType?: SubPaymentMethodTypeEnum;
	paymentMethodId: string;
	ccLast4?: string;
	ccBrand?: string;
	expMonth?: number;
	expYear?: number;
	deletedAt?: Date;
}

export interface UserPaymentMethodOption {
	paymentMethodType: PaymentMethodTypeEnum;
	subPaymentMethodType?: string;
	fee?: FeeDto;
	options?: UserPaymentMethod[];
}

export interface PaymentMethod {
	id: string;
	billing_details: {
		address: {
			city: string | null;
			country: string | null;
			line1: string | null;
			line2: string | null;
			postalCode: string | null;
			state: string | null;
		};
		email: string;
		name: string;
		phone: string;
		account_number: string;
	};
	card?: {
		brand: string;
		country?: string;
		exp_month: string;
		exp_year: string;
		fingerprint?: string;
		funding?: string;
		generated_from?: string | null;
		last4: string;
		isDefault: boolean;
	};
	us_bank_account?: {
		account_holder_type: string;
		account_type: string;
		bank_name: string;
		financial_connections_account: string;
		fingerprint: string;
		last4: string;
	};
	type: SelectablePaymentMethodType;
}

export interface PurchaseProduct {
	id: number;
	ordinal: number;
	parentOrdinal?: number;
	resources: ProductResource[];
	userId?: number;
	unitPrice: number;
	price?: number;
	quantity?: number;
}

export interface IPaymentPlanScheduleDto {
	date: Date;
	percent?: number;
	fixed?: number;
}

export interface IChargeScheduled {
	userId: number;
	invoiceId: number;
}

export interface IChargeScheduledBody {
	paymentMethodData: IPaymentMethodData;
	platform: PlatformsEnum;
	shiftId?: number;
	includedIds?: number[];
	excludedIds?: number[];
}
export interface TChargeScheduled {
	query: IChargeScheduled;
	body: IChargeScheduledBody;
}

export const DEFAULT_PAGE = 1;
export const DEFAULT_ITEMS_PER_PAGE = 4;

export interface IPaymentPlanDto {
	months?: number;
	dayOfMonth?: number;
	schedule?: IPaymentPlanScheduleDto[];
	status?: PaymentPlanStatusEnum;
	paymentPlanType?: PaymentPlanTypeEnum;
	startsInMonths?: number;
	installmentRepeat?: RepetitionUnit;
}

export interface ICalcPaymentPlanDto extends IPaymentPlanDto {
	amountToSplit: number;
}

export enum PaymentProcessorEnum {
	STRIPE = 'stripe',
	OTHER = 'other',
}
export interface IOrganizationPaymentMethod {
	paymentMethodType: PaymentMethodTypeEnum;
	paymentMethodProcessor: PaymentProcessorEnum;
	minimumAmount: number;
	daysToRefunds?: number;
	platform: PlatformsEnum;
	id: number;
	organizationId: number;
}

export type SelectablePaymentMethodType = PaymentMethodTypeEnum.CARD | PaymentMethodTypeEnum.ACH;

export interface IScheduledPayment {
	plannedDate: string;
	price: number;
}
